import {
	styled,
	AppBar as MuiAppBar,
	AppBarProps as MuiAppBarProps,
	IconButton,
} from '@mui/material';
import {
	APP_BAR_HEIGHT,
	getNavDrawerCollapsedWidth,
	NAV_DRAWER_WIDTH,
} from 'shared/_components/app-layout/constants';

type AppBarProps = MuiAppBarProps & { expanded: boolean, open: boolean };

export const AppBarStyled = styled(MuiAppBar, {
	shouldForwardProp: (prop: string) => !['expanded', 'open'].includes(prop),
})<AppBarProps>(({ theme, expanded }) => ({
	// zIndex: theme.zIndex.drawer + 1,
	height: APP_BAR_HEIGHT,
	transition: theme.transitions.create(['width', 'margin'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	// Same background as the page (body)
	backgroundColor: theme.palette.background.default,
	boxShadow: 'none',
	textAlign: 'center',
	borderBottom: `1px solid ${theme.palette.divider}`,
	width: `100%`,
	[theme.breakpoints.up('sm')]: {
		marginLeft: expanded ? undefined : NAV_DRAWER_WIDTH,
		transition: expanded
			? theme.transitions.create(['width', 'margin'], {
					easing: theme.transitions.easing.sharp,
					duration: theme.transitions.duration.enteringScreen,
			  }) : undefined,
		width: expanded
			? `calc(100% - ${NAV_DRAWER_WIDTH}px)`
			: `calc(100% - ${getNavDrawerCollapsedWidth(theme, 'sm')})`,
	},
	// ...(!expanded && {
	// 	width: `calc(100% - ${getNavDrawerCollapsedWidth(theme, 'xs')})`,
	// 	[theme.breakpoints.up('sm')]: {
	// 		width: `calc(100% - ${getNavDrawerCollapsedWidth(theme, 'sm')})`,
	// 	},
	// }),
	// ...(expanded && {
	// 	marginLeft: NAV_DRAWER_WIDTH,
	// 	width: `calc(100% - ${NAV_DRAWER_WIDTH}px)`,
	// 	transition: theme.transitions.create(['width', 'margin'], {
	// 		easing: theme.transitions.easing.sharp,
	// 		duration: theme.transitions.duration.enteringScreen,
	// 	}),
	// }),
}));

const TOGGLE_BUTTON_SIZE = 34; // small IconButton: 24px icon + 2 * 5px padding

/** Sidebar collapse button, centered on the edge between the sidebar and the page content (desktop only). */
export const DrawerToggle = styled('div', {
	shouldForwardProp: (prop: string) => prop !== 'expanded',
})<{ expanded: boolean }>(({ theme, expanded }) => ({
	display: 'none',
	[theme.breakpoints.up('sm')]: {
		display: 'block',
		position: 'fixed',
		top: (APP_BAR_HEIGHT - TOGGLE_BUTTON_SIZE) / 2,
		left: expanded ? NAV_DRAWER_WIDTH : getNavDrawerCollapsedWidth(theme, 'sm'),
		transform: 'translateX(-50%)',
		zIndex: theme.zIndex.drawer + 2,
		transition: theme.transitions.create('left', {
			easing: theme.transitions.easing.sharp,
			duration: expanded
				? theme.transitions.duration.enteringScreen
				: theme.transitions.duration.leavingScreen,
		}),
	},
}));

export const DrawerToggleButton = styled(IconButton)(({ theme }) => ({
	color: theme.palette.background.default,
	background: `radial-gradient(circle, ${theme.palette.primary.main} 0%, transparent 60%)`,
}));
